export const CHECKPOINT_LOADED = 'checkpoint_LOADED';
export const CHECKPOINT_SAVE = 'checkpoint_SAVE';
export const CHECKPOINT_RELOAD = 'checkpoint_RELOAD';
export const CHECKPOINT_RELOADED = 'checkpoint_RELOADED';
